import { useEffect } from 'react';
import './Landing.css';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from './Hero';
import { Work } from './Work';
import { About } from './About';
import { Experience } from './Experience';
import { Certifications } from './Certifications';
import { Contact } from './Contact';
import { Footer } from './Footer';

export const Landing = () => {
  // A section link on another page points at "/#section", so the browser looks
  // for that element while the page is still empty and gives up before React
  // has rendered it. The jump has to happen here instead. The second pass
  // corrects for images and fonts settling and shifting the target.
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return;

    let cancelled = false;
    const jump = () => {
      if (cancelled) return;
      // Instant, not smooth. Smooth would animate the full page height on
      // arrival, which reads as the page scrolling away on its own.
      document
        .getElementById(id)
        ?.scrollIntoView({ behavior: 'auto', block: 'start' });
    };

    const frame = requestAnimationFrame(jump);
    const settle = window.setTimeout(jump, 300);
    return () => {
      cancelled = true;
      cancelAnimationFrame(frame);
      window.clearTimeout(settle);
    };
  }, []);

  useEffect(() => {
    const revealEls = document.querySelectorAll('.landing .reveal');
    if (!revealEls.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    revealEls.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="landing">
      <SiteHeader />
      <Hero />
      <main>
        <Work />
        <About />
        <Experience />
        <Certifications />
      </main>
      <Contact />
      <Footer />
    </div>
  );
};
